import styled from "styled-components";

// This TextareaGhostDiv helps with the automatic expansion of
// <Textarea> as users type into it.
const TextareaGhostDiv = styled.div`
  outline: none;
  min-height: 60px;
  max-height: 200px;
  width: 100%;
  padding: 10px 15px 25px;
  box-shadow: none;
  display: block;
  border: 2px solid black;
  overflow: hidden;
  white-space: pre-wrap;
  word-wrap: break-word;
  visibility: hidden;
  position: absolute;
  top: 0;
`;

export default TextareaGhostDiv;
